/*
 * Free gift with minimum order.
 * - Progress bar (<free-gift-component>) uses the same markup/classes as the free shipping bar.
 * - Adds the gift product automatically at the minimum and removes it below the minimum.
 * Settings come from window.free_gift (see snippets/global-script.liquid).
 * The gift is only FREE when the matching automatic "Buy X get Y" discount exists in Shopify admin.
 */
(function () {
    'use strict';

    var CFG = window.free_gift;
    if (!CFG) return;

    var VARIANT_ID = Number(CFG.variantId) || 0;
    var AUTO_ADD = !!CFG.autoAdd && VARIANT_ID > 0;
    var ATTR_KEY = 'Free gift';
    var THRESHOLD = Math.round(Number(CFG.threshold) * 100); // minor units
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var busy = false;
    var queued = false;
    var lastCart = null;

    function request(path, body) {
        var opts = { headers: { 'Accept': 'application/json' }, cache: 'no-store' };
        if (body) {
            opts.method = 'POST';
            opts.headers['Content-Type'] = 'application/json';
            opts.body = JSON.stringify(body);
        }
        return fetch(ROOT + path, opts).then(function (r) { return r.json(); });
    }

    function getCart() { return request('cart.js'); }

    // Cart value that counts toward the minimum (gift line excluded), after discounts.
    function qualifyingTotal(cart) {
        return cart.items.reduce(function (sum, item) {
            return (VARIANT_ID && item.variant_id === VARIANT_ID) ? sum : sum + item.final_line_price;
        }, 0);
    }

    function money(cents) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents, window.money_format);
        }
        return (cents / 100).toFixed(2);
    }

    function fill(text, cents) {
        return String(text || '').replace('[amount]', money(cents));
    }

    // ---------- progress bar ----------
    function renderBars(cart) {
        var bars = document.querySelectorAll('free-gift-component');
        if (!bars.length) return;

        var total = qualifyingTotal(cart);
        var pct = THRESHOLD > 0 ? Math.min(100, (total * 100) / THRESHOLD) : 100;
        var cls, text, hidden = false;

        if (total <= 0) {
            hidden = true;
            cls = 'none';
            text = fill(CFG.textStart, THRESHOLD);
        } else if (total >= THRESHOLD) {
            cls = 'progress-free';
            text = CFG.textSuccess;
        } else {
            cls = pct <= 30 ? 'progress-30' : (pct <= 60 ? 'progress-60' : 'progress-100');
            text = fill(CFG.textProgress, THRESHOLD - total);
        }

        bars.forEach(function (bar) {
            var progress = bar.querySelector('[data-gift-progress]');
            var meter = bar.querySelector('[data-gift-progress-meter]');
            var message = bar.querySelector('[data-gift-message]');
            if (!progress || !meter || !message) return;

            progress.classList.toggle('progress-hidden', hidden);
            ['progress-30', 'progress-60', 'progress-100', 'progress-free'].forEach(function (c) {
                progress.classList.remove(c);
            });
            if (cls !== 'none') progress.classList.add(cls);

            meter.style.width = pct + '%';
            var label = meter.querySelector('.text');
            if (label && progress.dataset.textEnabled === 'true') label.textContent = pct.toFixed(2) + '%';
            message.textContent = text;

            // Display-only gift product (never added to the cart)
            var preview = bar.querySelector('[data-gift-preview]');
            if (preview && !AUTO_ADD) {
                var unlocked = total >= THRESHOLD && total > 0;
                preview.hidden = preview.dataset.mode === 'never' || (preview.dataset.mode === 'unlocked' && !unlocked);
                preview.classList.toggle('is-locked', !unlocked);
            }
        });
    }

    // ---------- refresh the theme's own cart UI after we change the cart ----------
    function refreshThemeCart(cart) {
        var fns = window.sharedFunctions || {};
        if (document.body.classList.contains('template-cart') && typeof fns.updateCart === 'function') {
            fns.updateCart(cart);
        } else if (typeof fns.updateSidebarCart === 'function') {
            fns.updateSidebarCart(cart);
        }
    }

    // Bar-only mode: nothing is added to the cart. We only tag the cart so staff can see who earned the gift.
    function syncBarOnly(cart) {
        lastCart = cart;
        renderBars(cart);
        var eligible = qualifyingTotal(cart) >= THRESHOLD && qualifyingTotal(cart) > 0;
        var current = (cart.attributes && cart.attributes[ATTR_KEY]) || '';
        var wanted = eligible ? 'Eligible (minimum order reached)' : '';
        if (current === wanted || (!eligible && !current)) return;
        var attrs = {}; attrs[ATTR_KEY] = wanted;
        return request('cart/update.js', { attributes: attrs });
    }

    // ---------- add / remove the gift ----------
    // knownCart: the cart object the theme just fetched (cart-update event). Using it avoids an extra request.
    function sync(knownCart) {
        if (busy) { queued = true; return Promise.resolve(); }
        busy = true;

        var source = (knownCart && Array.isArray(knownCart.items)) ? Promise.resolve(knownCart) : getCart();
        return source.then(function (cart) {
            if (!AUTO_ADD) { return syncBarOnly(cart); }
            var gift = cart.items.filter(function (i) { return i.variant_id === VARIANT_ID; })[0];
            var total = qualifyingTotal(cart);
            var action = null;

            if (total >= THRESHOLD && total > 0) {
                if (!gift) {
                    action = request('cart/add.js', { items: [{ id: VARIANT_ID, quantity: 1 }] });
                } else if (gift.quantity !== 1) {
                    action = request('cart/change.js', { id: gift.key, quantity: 1 });
                }
            } else if (gift) {
                action = request('cart/change.js', { id: gift.key, quantity: 0 });
            }

            if (!action) { lastCart = cart; renderBars(cart); return; }

            return action.then(getCart).then(function (fresh) {
                lastCart = fresh;
                renderBars(fresh);
                refreshThemeCart(fresh);
            });
        }).catch(function (e) {
            // e.g. gift out of stock: do nothing visible, never break the cart
            console.warn('[free-gift]', e);
        }).then(function () {
            busy = false;
            if (queued) { queued = false; sync(); }
        });
    }

    // <free-gift-component> redraws itself when the theme re-inserts it
    if (!customElements.get('free-gift-component')) {
        customElements.define('free-gift-component', class extends HTMLElement {
            connectedCallback() {
                if (lastCart) { renderBars(lastCart); } else { getCart().then(function (c) { lastCart = c; renderBars(c); }); }
            }
        });
    }

    // The theme fires "cart-update" after every cart change (add to cart, quantity, remove)
    document.addEventListener('cart-update', function (e) { sync(e && e.detail); });
    window.addEventListener('pageshow', function () { sync(); });
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', sync);
    } else {
        sync();
    }
})();
